// src/state/scopeStorage.js
const SCOPE_KEY = 'active-scope';

// Read (new + legacy)
export function readScope() {
  try {
    const scope = JSON.parse(localStorage.getItem(SCOPE_KEY) || 'null');
    if (scope?.org || scope?.dataset) return scope;
  } catch {}
  const orgId =
    localStorage.getItem('activeOrgId') ||
    localStorage.getItem('activeOrg') ||
    null;
  const orgName =
    localStorage.getItem('activeOrgName') ||
    localStorage.getItem('activeOrgLabel') ||
    null;
  const datasetId =
    localStorage.getItem('activeDataSetId') ||
    localStorage.getItem('datasetId') ||
    null;
  const datasetName =
    localStorage.getItem('activeDataSetName') ||
    localStorage.getItem('datasetName') ||
    null;

  return {
    org: orgId ? { id: orgId, name: orgName } : null,
    dataset: datasetId ? { id: datasetId, name: datasetName } : null,
  };
}

function writeLegacyOrg(org) {
  if (!org) {
    localStorage.removeItem('activeOrgId');
    localStorage.removeItem('activeOrg');
    localStorage.removeItem('activeOrgName');
    localStorage.removeItem('activeOrgLabel');
    return;
  }
  localStorage.setItem('activeOrgId', org.id);
  localStorage.setItem('activeOrg', org.id);
  if (org.name) {
    localStorage.setItem('activeOrgName', org.name);
    localStorage.setItem('activeOrgLabel', org.name);
  }
}

function writeLegacyDataset(ds) {
  if (!ds) {
    localStorage.removeItem('activeDataSetId');
    localStorage.removeItem('activeDataSetName');
    localStorage.removeItem('datasetId');
    localStorage.removeItem('datasetName');
    return;
  }
  localStorage.setItem('activeDataSetId', ds.id);
  localStorage.setItem('datasetId', ds.id);
  if (ds.name) {
    localStorage.setItem('activeDataSetName', ds.name);
    localStorage.setItem('datasetName', ds.name);
  }
}

function broadcast(scope) {
  // Notify same-tab listeners
  window.dispatchEvent(new CustomEvent('scope:changed', { detail: scope }));
}

export function setActiveOrg(org) {
  const scope = readScope();
  const next = { org, dataset: null }; // clear dataset on org change
  localStorage.setItem(SCOPE_KEY, JSON.stringify(next));
  writeLegacyOrg(org);
  writeLegacyDataset(null);
  broadcast(next);
  return next;
}

export function setActiveDataSet(dataset) {
  const scope = readScope();
  const next = { org: scope.org || null, dataset };
  localStorage.setItem(SCOPE_KEY, JSON.stringify(next));
  writeLegacyOrg(scope.org || null);
  writeLegacyDataset(dataset);
  broadcast(next);
  return next;
}

export function clearScope() {
  localStorage.removeItem(SCOPE_KEY);
  writeLegacyOrg(null);
  writeLegacyDataset(null);
  broadcast({ org: null, dataset: null });
}
